import { Eye, EyeOff } from 'lucide-react'

import { buttonClass } from '@/components/ui'
import { useValoresOcultosStore } from '@/stores/valoresOcultosStore'
import { cn } from '@/utils/cn'

/**
 * Botão "ocultar valores" do Topbar (rotas com `handle.valores`). Com rótulo e preenchido enquanto ativo, para
 * deixar claro na hora que os valores da tela estão mascarados.
 */
export function ValoresToggle({ className }: { className?: string }) {
  const ocultos = useValoresOcultosStore((state) => state.ocultos)
  const toggle = useValoresOcultosStore((state) => state.toggle)
  const label = ocultos ? 'Mostrar valores' : 'Ocultar valores'
  const Icon = ocultos ? EyeOff : Eye

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={label}
      aria-pressed={ocultos}
      title={label}
      className={cn(
        buttonClass({ variant: ocultos ? 'primary' : 'outline', size: 'sm' }),
        // No celular só o ícone, para caber na barra.
        'max-sm:w-9 max-sm:px-0',
        className,
      )}
    >
      <Icon className="size-4" />
      <span className="hidden sm:inline">{label}</span>
    </button>
  )
}
